export class Profile {
	id: number;
	mailinglist_id: number;
	name: string;
	extern_id: number;
	custom: boolean;

	num_subscribers: number;

	constructor() {

	}
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/profile.ts